// removed by extract-text-webpack-plugin
module.exports = {"root":"_9f66f868","noMargin":"e87ce420","paginationLoader":"bdcf7744"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Healthboard/Components/AppointmentList/styles.styl
// module id = 4965
// module chunks = 39